document.documentElement.classList.add('js');

const toggle = document.querySelector('[data-menu-toggle]');
const menu = document.getElementById('MobileMenu');
const close = menu?.querySelector('[data-menu-close]');

if (toggle && menu && close) {
  const setMenu = open => {
    toggle.setAttribute('aria-expanded', String(open));
    menu.hidden = !open;
    document.body.classList.toggle('menu-open', open);
    if (open) close.focus();
    else toggle.focus();
  };

  toggle.addEventListener('click', () => setMenu(menu.hidden));
  close.addEventListener('click', () => setMenu(false));
  menu.addEventListener('click', event => {
    if (event.target === menu) setMenu(false);
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !menu.hidden) setMenu(false);
  });
}

const cookieBanner = document.querySelector('[data-cookie-banner]');
if (cookieBanner && localStorage.getItem('therabreath-cookie-dismissed') !== '1') {
  cookieBanner.hidden = false;
  const dismissCookie = () => {
    localStorage.setItem('therabreath-cookie-dismissed', '1');
    cookieBanner.hidden = true;
  };
  cookieBanner.querySelectorAll('[data-cookie-dismiss]').forEach(button => {
    button.addEventListener('click', dismissCookie);
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !cookieBanner.hidden) dismissCookie();
  });
}

document.querySelectorAll('.product-card form').forEach(form => {
  form.addEventListener('submit', event => {
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (!button || button.disabled) return;
    const originalLabel = button.textContent;
    button.disabled = true;
    fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(response => {
        if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
        button.textContent = 'ADDED TO CART';
        window.TheraBreathCart?.refresh(true);
      })
      .catch(() => {
        button.textContent = originalLabel;
      })
      .finally(() => {
        window.setTimeout(() => {
          button.textContent = originalLabel;
          button.disabled = false;
        }, 1400);
      });
  });
});

const productRoot = document.querySelector('[data-product-root]');
if (productRoot) {
  const variantInput = productRoot.querySelector('[data-product-variant]');
  const optionInputs = [...productRoot.querySelectorAll('[data-product-option]')];
  const priceTarget = productRoot.querySelector('[data-product-price]');
  const submitButton = productRoot.querySelector('[data-product-submit]');
  const imageTarget = productRoot.querySelector('[data-main-product-image]');
  const variantsScript = productRoot.querySelector('[data-product-variants]');
  const variants = variantsScript ? JSON.parse(variantsScript.textContent || '[]') : [];
  const galleryButtons = [...productRoot.querySelectorAll('[data-product-thumb]')];
  const galleryCount = productRoot.querySelector('[data-gallery-count]');
  let currentGalleryIndex = Math.max(0, galleryButtons.findIndex(button => button.classList.contains('is-active')));

  const money = cents => {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
    return `$${(Number(cents) / 100).toFixed(2)}`;
  };

  const selectedOptions = () => {
    const values = [];
    optionInputs.forEach(input => {
      if (input.checked) values[Number(input.dataset.optionIndex)] = input.value;
    });
    return values;
  };

  const findVariant = () => {
    const options = selectedOptions();
    if (!options.length) return variants.find(item => String(item.id) === variantInput?.value) || variants[0];
    return variants.find(item => options.every((value, index) => value === undefined || item.options?.[index] === value || item[`option${index + 1}`] === value));
  };

  const setGalleryButton = button => {
    galleryButtons.forEach(item => {
      const active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-current', String(active));
    });
    if (button) {
      currentGalleryIndex = galleryButtons.indexOf(button);
      if (galleryCount) galleryCount.textContent = `${currentGalleryIndex + 1} / ${galleryButtons.length}`;
    }
  };

  const setImage = (src, alt, button) => {
    if (!imageTarget || !src) return;
    const normalizedSrc = src.startsWith('//') ? `${window.location.protocol}${src}` : src;
    imageTarget.removeAttribute('srcset');
    imageTarget.removeAttribute('sizes');
    imageTarget.src = normalizedSrc;
    if (alt) imageTarget.alt = alt;
    if (button) setGalleryButton(button);
  };

  const updatePrice = variant => {
    if (!priceTarget) return;
    const current = priceTarget.querySelector('.price__current');
    if (current) current.textContent = money(variant.price);
    let compare = priceTarget.querySelector('.price__compare');
    let badge = priceTarget.querySelector('.price__badge');
    if (Number(variant.compare_at_price) > Number(variant.price)) {
      const discount = Math.round((Number(variant.compare_at_price) - Number(variant.price)) * 100 / Number(variant.compare_at_price));
      if (!compare) {
        compare = document.createElement('s');
        compare.className = 'price__compare';
        priceTarget.append(compare);
      }
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'price__badge';
        priceTarget.append(badge);
      }
      compare.textContent = money(variant.compare_at_price);
      badge.textContent = `-${discount}%`;
    } else {
      compare?.remove();
      badge?.remove();
    }
  };

  const syncVariant = () => {
    const variant = findVariant();
    if (!variant) {
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Unavailable';
      }
      return;
    }
    if (variantInput) variantInput.value = variant.id;
    updatePrice(variant);
    if (submitButton) {
      submitButton.disabled = !variant.available;
      submitButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }
    const image = variant.featured_image?.src || variant.featured_image?.url || variant.featured_media?.preview_image?.src || variant.featured_media?.preview_image?.url;
    if (image) setImage(image, variant.title);
  };

  optionInputs.forEach(input => input.addEventListener('change', syncVariant));

  galleryButtons.forEach(button => {
    button.addEventListener('click', () => setImage(button.dataset.productThumb, button.dataset.productThumbAlt, button));
  });

  const moveGallery = direction => {
    if (!galleryButtons.length) return;
    const nextIndex = (currentGalleryIndex + direction + galleryButtons.length) % galleryButtons.length;
    const button = galleryButtons[nextIndex];
    setImage(button.dataset.productThumb, button.dataset.productThumbAlt, button);
    button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  };
  productRoot.querySelector('[data-gallery-prev]')?.addEventListener('click', () => moveGallery(-1));
  productRoot.querySelector('[data-gallery-next]')?.addEventListener('click', () => moveGallery(1));
  productRoot.querySelector('[data-product-zoom]')?.addEventListener('click', () => {
    if (imageTarget?.src) window.open(imageTarget.currentSrc || imageTarget.src, '_blank', 'noopener');
  });

  const quantityInput = productRoot.querySelector('.quantity-input');
  const setQuantity = value => {
    if (!quantityInput) return;
    quantityInput.value = String(Math.max(1, Number(value) || 1));
  };
  productRoot.querySelector('[data-quantity-decrease]')?.addEventListener('click', () => setQuantity(Number(quantityInput?.value) - 1));
  productRoot.querySelector('[data-quantity-increase]')?.addEventListener('click', () => setQuantity(Number(quantityInput?.value) + 1));
  quantityInput?.addEventListener('change', () => setQuantity(quantityInput.value));

  syncVariant();
}



const homeCarousel = document.querySelector('[data-home-carousel]');
if (homeCarousel) {
  const slidesTrack = homeCarousel.querySelector('.hero-carousel__slides');
  const slides = [...homeCarousel.querySelectorAll('[data-slide]')];
  const dots = [...homeCarousel.querySelectorAll('[data-carousel-dot]')];
  let activeIndex = 0;
  let timer;

  const showSlide = (index, animate = true) => {
    activeIndex = (index + slides.length) % slides.length;
    if (slidesTrack) {
      slidesTrack.style.transition = animate ? 'transform 0.4s cubic-bezier(0.25, 1, 0.5, 1)' : 'none';
      slidesTrack.style.transform = `translateX(-${activeIndex * 100}%)`;
    }
    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === activeIndex));
    dots.forEach((dot, i) => {
      const active = i === activeIndex;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', String(active));
    });
  };

  const restart = () => {
    window.clearInterval(timer);
    timer = window.setInterval(() => showSlide(activeIndex + 1), 7000);
  };

  homeCarousel.querySelector('[data-carousel-prev]')?.addEventListener('click', () => { showSlide(activeIndex - 1); restart(); });
  homeCarousel.querySelector('[data-carousel-next]')?.addEventListener('click', () => { showSlide(activeIndex + 1); restart(); });
  dots.forEach(dot => dot.addEventListener('click', () => { showSlide(Number(dot.dataset.carouselDot)); restart(); }));
  homeCarousel.addEventListener('mouseenter', () => window.clearInterval(timer));
  homeCarousel.addEventListener('mouseleave', restart);

  // Touch swipe support for mobile
  let touchStartX = 0;
  let touchStartY = 0;
  let touchCurrentX = 0;
  let isSwiping = false;
  let isHorizontal = null;
  let hasMoved = false;

  homeCarousel.addEventListener('touchstart', e => {
    if (e.touches.length !== 1) return;
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    touchCurrentX = touchStartX;
    isSwiping = true;
    isHorizontal = null;
    hasMoved = false;
    window.clearInterval(timer);
  }, { passive: true });

  homeCarousel.addEventListener('touchmove', e => {
    if (!isSwiping || e.touches.length !== 1) return;
    touchCurrentX = e.touches[0].clientX;
    const diffX = touchCurrentX - touchStartX;
    const diffY = e.touches[0].clientY - touchStartY;

    if (isHorizontal === null) {
      if (Math.abs(diffX) > 5 || Math.abs(diffY) > 5) {
        isHorizontal = Math.abs(diffX) > Math.abs(diffY);
      }
    }

    if (isHorizontal) {
      if (e.cancelable) e.preventDefault();
      hasMoved = true;
      if (slidesTrack) {
        slidesTrack.style.transition = 'none';
        const carouselWidth = homeCarousel.offsetWidth || 1;
        const currentOffsetPercent = -activeIndex * 100;
        const dragPercent = (diffX / carouselWidth) * 100;
        slidesTrack.style.transform = `translateX(${currentOffsetPercent + dragPercent}%)`;
      }
    }
  }, { passive: false });

  const handleTouchEnd = () => {
    if (!isSwiping) return;
    isSwiping = false;
    if (isHorizontal && hasMoved) {
      const diffX = touchCurrentX - touchStartX;
      const carouselWidth = homeCarousel.offsetWidth || 1;
      const threshold = Math.min(60, carouselWidth * 0.15);
      if (diffX < -threshold) {
        showSlide(activeIndex + 1);
      } else if (diffX > threshold) {
        showSlide(activeIndex - 1);
      } else {
        showSlide(activeIndex);
      }
    } else {
      showSlide(activeIndex);
    }
    restart();
  };

  homeCarousel.addEventListener('touchend', handleTouchEnd, { passive: true });
  homeCarousel.addEventListener('touchcancel', handleTouchEnd, { passive: true });

  // Prevent accidental navigation when swiping
  homeCarousel.addEventListener('click', e => {
    if (hasMoved) {
      e.preventDefault();
      e.stopPropagation();
      hasMoved = false;
    }
  }, true);

  showSlide(0, false);
  restart();
}

document.querySelectorAll('[data-faq-page] .accordion-pdp').forEach(button => {
  button.addEventListener('click', () => {
    const panel = button.nextElementSibling;
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
    button.classList.toggle('active', !expanded);
    if (panel) panel.hidden = expanded;
  });
});


const megaMenu = document.querySelector('.site-nav__item--mega');
if (megaMenu) {
  document.addEventListener('click', event => {
    if (!megaMenu.contains(event.target)) megaMenu.removeAttribute('open');
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && megaMenu.hasAttribute('open')) {
      megaMenu.removeAttribute('open');
      megaMenu.querySelector('summary')?.focus();
    }
  });
}

const overlayBackdrop = document.querySelector('[data-overlay-backdrop]');
const searchOverlay = document.querySelector('[data-search-overlay]');
const searchInput = document.querySelector('[data-search-input]');
const cartDrawer = document.querySelector('[data-cart-drawer]');

const setOverlay = (type, open) => {
  const target = type === 'search' ? searchOverlay : cartDrawer;
  const other = type === 'search' ? cartDrawer : searchOverlay;
  if (!target) return;
  target.hidden = !open;
  if (other) other.hidden = true;
  if (overlayBackdrop) overlayBackdrop.hidden = !open;
  document.body.classList.toggle('drawer-open', open);
  if (open && type === 'search') searchInput?.focus();
};

document.querySelector('[data-search-open]')?.addEventListener('click', () => setOverlay('search', true));
document.querySelector('[data-search-close]')?.addEventListener('click', () => setOverlay('search', false));
document.querySelector('[data-cart-open]')?.addEventListener('click', () => setOverlay('cart', true));
document.querySelector('[data-cart-close]')?.addEventListener('click', () => setOverlay('cart', false));
overlayBackdrop?.addEventListener('click', () => { setOverlay('search', false); setOverlay('cart', false); });
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') { setOverlay('search', false); setOverlay('cart', false); }
});

if (searchOverlay && searchInput) {
  const suggestionsTarget = searchOverlay.querySelector('[data-search-suggestions]');
  const pagesTarget = searchOverlay.querySelector('[data-search-pages]');
  const productsTarget = searchOverlay.querySelector('[data-search-products]');
  const footerQuery = searchOverlay.querySelector('[data-search-footer-query]');
  const searchAll = searchOverlay.querySelector('[data-search-all]');
  const clearButton = searchOverlay.querySelector('[data-search-clear]');
  let requestId = 0;
  const escapeHtml = value => String(value).replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character]);
  const renderResults = (query, payload) => {
    const products = payload?.resources?.results?.products || [];
    const pages = payload?.resources?.results?.pages || [];
    const terms = query ? [query, `${query} mouthwash`, `${query} toothpaste`] : [];
    suggestionsTarget.innerHTML = terms.map(term => `<a href="/search?type=product&q=${encodeURIComponent(term)}">${escapeHtml(term)}</a>`).join('');
    pagesTarget.innerHTML = pages.slice(0, 4).map(page => `<a href="${escapeHtml(page.url)}">${escapeHtml(page.title)}</a>`).join('');
    productsTarget.innerHTML = products.slice(0, 4).map(product => `<a class="search-product" href="${escapeHtml(product.url)}"><span class="search-product__image">${product.image?.url ? `<img src="${escapeHtml(product.image.url)}" alt="${escapeHtml(product.title)}" loading="lazy">` : ''}</span><strong>${escapeHtml(product.title)}</strong></a>`).join('');
    searchAll.href = query ? `/search?type=product&q=${encodeURIComponent(query)}` : '/search';
    footerQuery.textContent = query ? `“${query}”` : '';
  };
  const loadResults = query => {
    const currentRequest = ++requestId;
    if (!query) { renderResults('', {}); return; }
    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,page&resources[limit]=4`, { headers: { Accept: 'application/json' } })
      .then(response => response.ok ? response.json() : {})
      .then(payload => { if (currentRequest === requestId) renderResults(query, payload); });
  };
  searchInput.addEventListener('input', () => loadResults(searchInput.value.trim()));
  clearButton?.addEventListener('click', () => { searchInput.value = ''; loadResults(''); searchInput.focus(); });
  renderResults('', {});
}

if (cartDrawer) {
  const itemsTarget = cartDrawer.querySelector('[data-cart-items]');
  const emptyTarget = cartDrawer.querySelector('[data-cart-empty]');
  const totalTarget = cartDrawer.querySelector('[data-cart-total]');
  const footerTarget = cartDrawer.querySelector('[data-cart-footer]');
  let cartCount = document.querySelector('.cart-count');
  const money = cents => `$${(Number(cents) / 100).toFixed(2)}`;
  const escapeHtml = value => String(value).replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character]);
  const renderCart = cart => {
    if (!itemsTarget || !emptyTarget || !totalTarget) return;
    itemsTarget.innerHTML = cart.items.map((item, index) => `<article class="cart-item" data-cart-item data-line="${index + 1}"><a href="${escapeHtml(item.url)}" class="cart-item__image">${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}">` : ''}</a><div class="cart-item__info"><a href="${escapeHtml(item.url)}" class="cart-item__title">${escapeHtml(item.product_title)}</a><p class="cart-item__price">${money(item.final_price)}</p>${item.variant_title && item.variant_title !== 'Default Title' ? `<p>Size: ${escapeHtml(item.variant_title)}</p>` : ''}<div class="cart-item__controls"><div class="cart-quantity"><button type="button" data-cart-decrease aria-label="Decrease quantity">−</button><span data-cart-quantity>${item.quantity}</span><button type="button" data-cart-increase aria-label="Increase quantity">+</button></div><button class="cart-item__remove" type="button" data-cart-remove aria-label="Remove ${escapeHtml(item.product_title)}">♜</button></div></div><strong class="cart-item__total">${money(item.final_line_price)}</strong></article>`).join('');
    emptyTarget.hidden = cart.item_count > 0;
    if (footerTarget) footerTarget.hidden = cart.item_count === 0;
    totalTarget.textContent = `${money(cart.total_price)} USD`;
    if (!cartCount && cart.item_count > 0) {
      cartCount = document.createElement('span');
      cartCount.className = 'cart-count';
      document.querySelector('[data-cart-open]')?.append(cartCount);
    }
    if (cartCount) { cartCount.textContent = cart.item_count; cartCount.hidden = cart.item_count === 0; }
  };
  const refresh = open => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(response => response.json()).then(cart => { renderCart(cart); if (open) setOverlay('cart', true); return cart; });
  const changeLine = (line, quantity) => fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity: Math.max(0, quantity) }) }).then(response => response.json()).then(renderCart);
  itemsTarget?.addEventListener('click', event => {
    const button = event.target.closest('button');
    const item = event.target.closest('[data-cart-item]');
    if (!button || !item) return;
    const quantity = Number(item.querySelector('[data-cart-quantity]')?.textContent || 1);
    const next = button.hasAttribute('data-cart-remove') ? 0 : quantity + (button.hasAttribute('data-cart-increase') ? 1 : -1);
    changeLine(Number(item.dataset.line), next);
  });
  window.TheraBreathCart = { refresh };
}

 document.querySelectorAll('.product-detail__form').forEach(form => {
  form.addEventListener('submit', event => {
    event.preventDefault();
    const button = form.querySelector('[data-product-submit]');
    if (!button || button.disabled) return;
    const originalLabel = button.textContent;
    button.disabled = true;
    fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(response => { if (!response.ok) throw new Error(`Cart request failed: ${response.status}`); button.textContent = 'ADDED TO CART'; return window.TheraBreathCart?.refresh(true); })
      .catch(() => { button.textContent = originalLabel; })
      .finally(() => window.setTimeout(() => { button.textContent = originalLabel; button.disabled = false; }, 1400));
  });
});

const reviewsPage = document.querySelector('[data-reviews-page]');
if (reviewsPage) {
  const dataNode = reviewsPage.querySelector('[data-review-data]');
  const list = reviewsPage.querySelector('[data-reviews-list]');
  const pagination = reviewsPage.querySelector('[data-review-pagination]');
  const productFilter = reviewsPage.querySelector('[data-review-product]');
  const sortFilter = reviewsPage.querySelector('[data-review-sort]');
  const dialog = reviewsPage.querySelector('[data-review-dialog]');
  const reviews = JSON.parse(dataNode?.textContent || '[]');
  const averageTarget = reviewsPage.querySelector('[data-review-average]');
  const countTarget = reviewsPage.querySelector('[data-review-count]');
  const pageSize = 6;
  let page = 1;
  const escapeHtml = value => String(value).replace(/[&<>"']/g, character => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' })[character]);
  const filteredReviews = () => {
    const selected = productFilter.value;
    const result = reviews.filter(review => selected === 'all' || review.product === selected);
    if (sortFilter.value === 'helpful') return result.sort((a, b) => b.helpful - a.helpful);
    if (sortFilter.value === 'highest') return result.sort((a, b) => b.rating - a.rating || b.date.localeCompare(a.date));
    return result.sort((a, b) => b.date.localeCompare(a.date));
  };
  const render = () => {
    const result = filteredReviews();
    const totalPages = Math.max(1, Math.ceil(result.length / pageSize));
    page = Math.min(page, totalPages);
    const visible = result.slice((page - 1) * pageSize, page * pageSize);
    const average = result.length ? (result.reduce((total, review) => total + review.rating, 0) / result.length).toFixed(1) : '0.0';
    averageTarget.textContent = average;
    averageTarget.nextElementSibling?.setAttribute('aria-label', average + ' out of 5 stars');
    countTarget.textContent = result.length;
    list.innerHTML = visible.map(review => `<article class="review-item"><div class="review-item__top"><span class="review-item__author">${escapeHtml(review.author)}</span><span class="review-item__date">${escapeHtml(new Date(`${review.date}T12:00:00`).toLocaleDateString('en-US',{month:'long',day:'numeric',year:'numeric'}))}</span></div><div class="review-item__product">${escapeHtml(review.productTitle)}</div><div class="review-stars" aria-label="${review.rating} out of 5 stars">${'★'.repeat(review.rating)}${'☆'.repeat(5-review.rating)}</div><p>${escapeHtml(review.body)}</p><div class="review-item__meta"><span class="review-verified">✓ Verified purchase</span><button type="button" data-helpful="${escapeHtml(review.author)}">Helpful (${review.helpful})</button></div></article>`).join('');
    pagination.innerHTML = Array.from({length: totalPages}, (_, index) => `<button type="button" class="${index + 1 === page ? 'is-active' : ''}" data-review-page="${index + 1}" aria-label="Go to page ${index + 1}" aria-current="${index + 1 === page ? 'page' : 'false'}">${index + 1}</button>`).join('');
  };
  productFilter.addEventListener('change', () => { page = 1; render(); });
  sortFilter.addEventListener('change', () => { page = 1; render(); });
  pagination.addEventListener('click', event => { const button = event.target.closest('[data-review-page]'); if (button) { page = Number(button.dataset.reviewPage); render(); reviewsPage.scrollIntoView({behavior:'smooth', block:'start'}); } });
  list.addEventListener('click', event => { const button = event.target.closest('[data-helpful]'); if (button && !button.dataset.clicked) { button.dataset.clicked = 'true'; button.textContent = `Helpful (${Number(button.textContent.match(/\\d+/)?.[0] || 0) + 1})`; } });
  reviewsPage.querySelector('[data-review-write]').addEventListener('click', () => dialog.showModal());
  reviewsPage.querySelector('[data-review-form]').addEventListener('submit', () => { reviewsPage.querySelector('[data-review-note]').hidden = false; });
  const requestedProduct = new URLSearchParams(window.location.search).get('product');
  if (requestedProduct && [...productFilter.options].some(option => option.value === requestedProduct)) productFilter.value = requestedProduct;
  render();
}


